import { useContext, useEffect, useState } from "react";
import RevokeForm from "./RevokeForm";
import CancelForm from "./CancelForm";
import PanelTitle from "../global/PanelTitle";
import PurchasesTable from "./PurchasesTable";
import AddPurchaseForm from "./AddPurchaseForm";
import Pagination from "../global/Pagination";
import { ModalContext } from "../../context/ModalContext";
import { CustomerContext } from "../../context/CustomerContext";
import { PurchasesContext } from "../../context/PurchasesContext";

const PAGE_SIZE = 20;

const CustomerPurchases = ({ customer_id }) => {
  const [page, setPage] = useState(1);
  const { modalComponent } = useContext(ModalContext);
  const { customer, extenderAcceso } = useContext(CustomerContext);

  const {
    total,
    purchases,
    cancelPurchase,
    revokePurchase,
    editExpiration,
    getCustomerPurchases,
  } = useContext(PurchasesContext);

  useEffect(() => {
    getCustomerPurchases({ page, customer_id });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, customer_id]);

  const toggleModal = () => {
    modalComponent(
      "Agregar Acceso",
      <AddPurchaseForm customer={customer} extenderAcceso={extenderAcceso} />
    );
  };

  const confirmRevoke = (purchase) => {
    modalComponent(
      "Precaución",
      <RevokeForm
        purchase={purchase}
        customer_id={customer_id}
        revokePurchase={revokePurchase}
      />
    );
  };

  const confirmCancel = (purchase) => {
    modalComponent(
      "Precaución",
      <CancelForm
        purchase={purchase}
        customer_id={customer_id}
        cancelPurchase={cancelPurchase}
      />
    );
  };
  const orderedPurchases = (purchases || []).sort((a, b) => {
    const dateA = new Date(a.createdAt);
    const dateB = new Date(b.createdAt);
    return dateB - dateA;
  });

  return (
    <div className="card p-3 pb-1 no-scale my-3">
      <PanelTitle title="Compras" onClick={toggleModal} />
      {Array.isArray(purchases) ? (
        <PurchasesTable
          hideColumns={["type", "customer"]}
          editExpiration={editExpiration}
          purchases={orderedPurchases ? orderedPurchases : []}
          confirmRevoke={confirmRevoke}
          confirmCancel={confirmCancel}
        />
      ) : (
        <div className="spinner-border mb-3" />
      )}
      {total > PAGE_SIZE && (
        <Pagination
          totalItems={total}
          currentPage={page}
          itemsPerPage={PAGE_SIZE}
          onPageChange={setPage}
        />
      )}
    </div>
  );
};

export default CustomerPurchases;
